import React from 'react';
import { Button } from 'reactstrap';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const ButtonRandomizeCode = ({ onClick }) => {
  return (
    <StyledButton onClick={onClick}>
      <i className="bx bx-repost" style={{ fontSize: '1.5rem', color: 'white' }} />
    </StyledButton>
  );
};

const StyledButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 4em;
  padding: 0 0;
  background: #f1b44c;
  border: none;

  &:hover {
    background: #d99a36 !important;
  }
`;

ButtonRandomizeCode.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default ButtonRandomizeCode;
